var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9492 1.96875C19.1641 2.14062 19.1641 2.48438 18.9492 2.69922L9.96875 11.6797C9.75391 11.8945 9.45312 11.8945 9.23828 11.6797L0.257812 2.69922C0.0429688 2.48438 0.0429688 2.14062 0.257812 1.96875L1.07422 1.10938C1.28906 0.894531 1.63281 0.894531 1.80469 1.10938L9.625 8.88672L17.4023 1.10938C17.5742 0.894531 17.918 0.894531 18.1328 1.10938L18.9492 1.96875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.cbe2c619b6ce3d31dad4ceac7f3add6e.svg";
export { ForwardRef as ReactComponent };